module.exports = __webpack_public_path__ + "img/logo.f7ec6306.svg";